import * as React from 'react'

function SabaFlag(props) {
  return (
    <svg width="1em" height="1em" viewBox="-750 -500 1500 1000" {...props}>
      <path d="M750 500H-750V-500H750z" fill="#dc171d" />
      <path d="M750 500H-750V0H750z" fill="#012a87" />
      <path d="M0 500L-750 0 0-500 750 0z" fill="#fff" />
      <g id="prefix__c">
        <g id="prefix__b">
          <path
            d="M0-283V0h142z"
            fill="#f9d90f"
            transform="rotate(18 0 -283)"
            id="prefix__a"
          />
          <use xlinkHref="#prefix__a" transform="scale(-1 1)" />
        </g>
        <use xlinkHref="#prefix__b" transform="rotate(72)" />
      </g>
      <use xlinkHref="#prefix__b" transform="rotate(-72)" />
      <use xlinkHref="#prefix__c" transform="rotate(144)" />
    </svg>
  )
}

const MemoSabaFlag = React.memo(SabaFlag)
export default MemoSabaFlag
